// Constants
import { FloodgateActivity } from "@ms/uno-constants/lib/local/FloodgateConstants";
// Controls
import { PageHeaderLayout } from "@ms/planner-generic-controls/lib/local/pageHeaderLayout/PageHeaderLayout";
// Styles
import { useUserViewHeaderStyles } from "./UserViewHeader.styles";
// Utilities
import * as React from "react";
export const UserViewHeader = ({ title, titleTestId, iconElement, pageLinksContent, trialButton, showMoreButton, headerOverflowMenu, logFloodgateActivity, shouldDisplayLoadingIndicator })=>{
    const styles = useUserViewHeaderStyles();
    React.useEffect(()=>{
        logFloodgateActivity?.(FloodgateActivity.PageHeader);
    }, [
        logFloodgateActivity
    ]);
    return /*#__PURE__*/ React.createElement(PageHeaderLayout, {
        title: /*#__PURE__*/ React.createElement("div", {
            className: styles.pageTitle
        }, /*#__PURE__*/ React.createElement("div", {
            className: styles.iconWrapper
        }, iconElement), /*#__PURE__*/ React.createElement("h2", {
            className: styles.title,
            "data-testid": titleTestId
        }, title)),
        actions: /*#__PURE__*/ React.createElement("div", {
            className: styles.pageLinks
        }, pageLinksContent, trialButton, showMoreButton && headerOverflowMenu),
        shouldDisplayLoadingIndicator: shouldDisplayLoadingIndicator
    });
};
